{
  "dropzoneLabel": "DropZone",
  "selectPlaceholder": "Selecteer een item",
  "tableResizer": "Resizer"
}
